(() => {
  const instances = new Map();
  function updatePriceDisplay(price, variant) {
    if (!price) return;
    price.querySelector('.price__current').textContent = variant?.price || '—';
    const sale = Boolean(variant?.compare) && Number(variant.compareCents) > Number(variant.priceCents);
    let compare = price.querySelector('.price__compare');
    if (!compare && sale) {
      compare = document.createElement('s');
      compare.className = 'price__compare';
      price.append(compare);
    }
    if (compare) {
      compare.textContent = sale ? variant.compare : '';
      compare.hidden = !sale;
    }
    let label = price.querySelector('[data-price-sale-label]');
    if (!label && sale) {
      label = document.createElement('span');
      label.className = 'price__sale-label';
      label.dataset.priceSaleLabel = '';
      price.append(label);
    }
    if (label) {
      const saving = sale ? Math.round((Number(variant.compareCents) - Number(variant.priceCents)) / Number(variant.compareCents) * 100) : 0;
      label.textContent = sale ? `Save ${saving}%` : '';
      label.hidden = !sale;
    }
    price.dataset.priceCents = variant?.priceCents || '';
    price.dataset.compareCents = sale ? variant.compareCents : '';
    price.classList.toggle('price--sale', sale);
  }
  function mount(root) {
    if (instances.has(root)) return;
    const form = root.querySelector('[data-product-form]');
    const master = root.querySelector('[data-variant-id]');
    let variants;
    try { variants = JSON.parse(root.querySelector('[data-product-json]').textContent); } catch { return; }
    if (!form || !master || !variants.length) return;
    const lifecycle = new AbortController();
    const on = (target, type, fn, options = {}) => target.addEventListener(type, fn, { ...options, signal: lifecycle.signal });
    const selects = [...root.querySelectorAll('[data-product-option]')];
    const quantity = root.querySelector('[data-quantity-input]');
    const items = [...root.querySelectorAll('[data-media-id]')];
    const thumbs = [...root.querySelectorAll('[data-media-target]')];
    const zoom = root.querySelector('[data-product-zoom-dialog]');
    const zoomButton = root.querySelector('[data-product-zoom]');
    const sticky = root.querySelector('[data-sticky-buy]');
    let activeMedia = Math.max(0, items.findIndex(item => !item.hidden));
    let frame = 0;
    root.classList.add('is-enhanced');
    function showMedia(index) {
      if (!items.length) return;
      activeMedia = (index + items.length) % items.length;
      items.forEach((item, i) => {
        if (i !== activeMedia && !item.hidden) {
          item.querySelectorAll('video').forEach(video => video.pause());
          item.querySelectorAll('iframe').forEach(iframe => { iframe.src = iframe.src; });
        }
        item.hidden = i !== activeMedia;
        item.classList.toggle('is-active', i === activeMedia);
      });
      thumbs.forEach((thumb, i) => {
        thumb.classList.toggle('is-active', i === activeMedia);
        thumb.setAttribute('aria-pressed', String(i === activeMedia));
      });
      const thumb = thumbs[activeMedia];
      if (thumb) {
        const rail = thumb.parentElement;
        rail.scrollTo({ left: Math.max(0, thumb.offsetLeft - rail.offsetLeft - rail.clientWidth / 2 + thumb.clientWidth / 2), behavior: 'instant' });
      }
      const count = root.querySelector('[data-gallery-count]');
      if (count) count.textContent = `${activeMedia + 1} / ${items.length}`;
      if (zoomButton) zoomButton.hidden = !items[activeMedia].querySelector('img');
    }
    function normalizeQuantity() {
      const min = Number(quantity.min) || 1;
      const step = Number(quantity.step) || 1;
      const rawMax = quantity.max ? Number(quantity.max) : Infinity;
      const max = Number.isFinite(rawMax) ? min + Math.floor((rawMax - min) / step) * step : Infinity;
      const value = Number(quantity.value) || min;
      quantity.value = Math.max(min, Math.min(max, min + Math.round((value - min) / step) * step));
      root.querySelector('[data-quantity-minus]').disabled = Number(quantity.value) <= min;
      root.querySelector('[data-quantity-plus]').disabled = Number(quantity.value) >= max;
    }
    function update(variant, { media = true, url = true, announce = true } = {}) {
      const available = !!variant?.available;
      master.disabled = !variant;
      master.value = variant ? String(variant.id) : '';
      root.querySelectorAll('[data-add-to-cart]').forEach(button => { button.disabled = !available; });
      root.querySelectorAll('[data-product-express]').forEach(element => { element.hidden = !available; });
      root.querySelectorAll('[data-add-label]').forEach(label => { label.textContent = variant ? (available ? 'Add to cart' : 'Sold out') : 'Unavailable'; });
      root.querySelector('[data-product-availability]').textContent = variant ? (available ? 'Available to order' : 'Sold out') : 'Combination unavailable';
      const price = root.querySelector('.product-info__price-row .price');
      updatePriceDisplay(price, variant);
      root.querySelectorAll('[data-variant-choice]').forEach(tile => tile.setAttribute('aria-pressed', String(!!variant && tile.dataset.variantChoice === String(variant.id))));
      selects.forEach((select, index) => {
        if (variant) select.value = variant.options[index];
        root.querySelector(`[data-option-label="${index}"]`).textContent = select.value;
      });
      if (variant) {
        quantity.min = variant.min || 1; quantity.step = variant.step || 1;
        if (variant.max !== null && variant.max !== undefined) quantity.max = variant.max;
        else quantity.removeAttribute('max');
        normalizeQuantity();
        if (media) {
          const index = items.findIndex(item => item.dataset.mediaId === String(variant.mediaId));
          if (index >= 0) showMedia(index);
        }
      }
      if (sticky) {
        sticky.querySelector('[data-sticky-price]').textContent = variant?.price || '';
        sticky.querySelector('[data-sticky-option]').textContent = variant?.title || 'Combination unavailable';
      }
      if (url) {
        const next = new URL(location.href);
        if (variant) next.searchParams.set('variant', variant.id);
        else next.searchParams.delete('variant');
        history.replaceState({}, '', next);
      }
      if (announce) root.querySelector('[data-product-status]').textContent = variant ? `${variant.title}. ${variant.price}. ${available ? 'Available to order.' : 'Sold out.'}` : 'This combination is unavailable. Please choose another option.';
      form.dispatchEvent(new Event('change', { bubbles: true }));
    }
    function syncSticky() {
      if (!sticky) return;
      const headerBottom = document.querySelector('.site-header')?.getBoundingClientRect().bottom || 0;
      const purchaseBottom = root.querySelector('[data-product-purchase]').getBoundingClientRect().bottom;
      const footerTop = document.querySelector('.site-footer')?.getBoundingClientRect().top ?? Infinity;
      sticky.hidden = purchaseBottom > Math.max(0, headerBottom) || footerTop < 120;
    }
    const requestSticky = () => {
      if (frame) return;
      frame = requestAnimationFrame(() => { frame = 0; syncSticky(); });
    };
    on(root, 'click', event => {
      const thumb = event.target.closest('[data-media-target]');
      if (thumb) showMedia(items.findIndex(item => item.dataset.mediaId === thumb.dataset.mediaTarget));
      if (event.target.closest('[data-gallery-prev]')) showMedia(activeMedia - 1);
      if (event.target.closest('[data-gallery-next]')) showMedia(activeMedia + 1);
      const choice = event.target.closest('[data-variant-choice]');
      if (choice) update(variants.find(v => String(v.id) === choice.dataset.variantChoice));
      if (event.target.closest('[data-quantity-minus]')) { quantity.value = Number(quantity.value) - Number(quantity.step || 1); normalizeQuantity(); }
      if (event.target.closest('[data-quantity-plus]')) { quantity.value = Number(quantity.value) + Number(quantity.step || 1); normalizeQuantity(); }
      if (event.target.closest('[data-product-zoom]') && zoom) {
        const photo = items[activeMedia]?.querySelector('img');
        const enlarged = zoom.querySelector('img');
        if (photo && enlarged) {
          enlarged.src = photo.src; enlarged.removeAttribute('srcset'); enlarged.alt = photo.alt;
          zoom.showModal();
        }
      }
      if (event.target.closest('[data-product-zoom-close]')) zoom?.close();
      if (event.target === zoom) {
        const r = zoom.getBoundingClientRect();
        if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) zoom.close();
      }
    });
    on(root, 'change', event => {
      if (event.target.matches('[data-product-option]')) update(variants.find(v => v.options.every((value, i) => String(value) === selects[i].value)));
      if (event.target === master) update(variants.find(v => String(v.id) === master.value));
      if (event.target === quantity) normalizeQuantity();
    });
    on(quantity, 'blur', normalizeQuantity);
    on(form, 'submit', event => {
      const selected = variants.find(v => String(v.id) === master.value);
      if (!selected?.available) { event.preventDefault(); update(selected, { media: false, url: false }); return; }
      normalizeQuantity();
    });
    if (zoom) on(zoom, 'close', () => zoomButton?.focus());
    on(window, 'scroll', requestSticky, { passive: true });
    on(window, 'resize', requestSticky);
    on(window, 'popstate', () => {
      const id = new URL(location.href).searchParams.get('variant');
      update(variants.find(v => String(v.id) === id) || variants.find(v => v.available) || variants[0], { url: false });
    });
    update(variants.find(v => String(v.id) === master.value) || variants[0], { media: false, url: false, announce: false });
    syncSticky();
    instances.set(root, () => { lifecycle.abort(); if (frame) cancelAnimationFrame(frame); zoom?.close(); });
  }
  const init = (scope = document) => scope.querySelectorAll('[data-product-root]').forEach(mount);
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-product-root]').forEach(root => { instances.get(root)?.(); instances.delete(root); });
  });
})();
